// src/components/PackingLists/AddItemForm.js
import React from 'react';
import { Button } from 'react-bootstrap';

/**
 * AddItemForm component provides form for adding new items to the packing list
 * 
 * @param {Object} props - Component props
 * @param {Object} props.newItem - New item form state
 * @param {Function} props.setNewItem - Function to update new item form state
 * @param {Function} props.addItem - Function to add a new item to the list
 * @param {Function} props.handleLocationChange - Function to handle location dropdown change
 * @param {Function} props.handleCategoryChange - Function to handle category dropdown change
 * @param {Array} props.storageLocations - Available storage locations
 * @param {Array} props.categories - Available categories
 * @returns {JSX.Element} Rendered component
 */
const AddItemForm = ({ 
  newItem, 
  setNewItem, 
  addItem, 
  handleLocationChange, 
  handleCategoryChange, 
  storageLocations, 
  categories 
}) => {
  return (
    <form className="listing-add-item-form" onSubmit={addItem}>
  <div className="row g-3">
    <div className="col-12 col-md-4">
      <input
        type="text"
        className="form-control"
        placeholder="Item name"
        value={newItem.name}
        onChange={(e) => setNewItem({...newItem, name: e.target.value})}
        required
      />
    </div>
    
    <div className="col-4 col-md-2">
      <input
        type="number"
        className="form-control"
        placeholder="Qty"
        min="1"
        value={newItem.quantity}
        onChange={(e) => setNewItem({...newItem, quantity: parseInt(e.target.value)})}
      />
    </div>
    
    <div className="col-8 col-md-2">
      <select
        className="form-select"
        value={newItem.location}
        onChange={handleLocationChange}
      >
        <option value="">Location</option>
        {storageLocations.map(location => (
          <option key={location.id} value={location.name}>
            {location.name}
          </option>
        ))}
        <option value="add_new">+ Add New</option>
      </select>
    </div>

    <div className="col-8 col-md-2">
      <select
        className="form-select"
        value={newItem.category}
        onChange={handleCategoryChange}
        required
      >
        <option value="">Category</option>
        {categories.map(category => (
          <option key={category.id} value={category.name}>{category.name}</option>
        ))}
        <option value="add_new">+ Add New</option>
      </select>
    </div>

    <div className="col-4 col-md-2">
      <Button 
        type="submit" 
        variant="primary"
        disabled={!newItem.name}
        className="w-100"
      >
        Add
      </Button>
    </div>
  </div>
</form>
  );
};

export default AddItemForm;